<!--
 * @Author       : JiangChao
 * @Date         : 2021-07-01 15:16:04
 * @LastEditors  : JiangChao
 * @LastEditTime : 2021-07-19 21:28:49
 * @Description  : pdf详情页
-->
<template>
  <div class="container">
    <img class="icon-pdf-style" :src="require('@/assets/icon/icon_pdf.png')" />
    <p>{{ this.fileName }}</p>
    <p>{{ Math.round(this.fileSize / 1024) }}KB</p>
    <p style="margin-top: 35px">
      点击下载后，可点击右上角【•••】将文件保存到手机
    </p>
    <div class="down" @click="download()">下载</div>
    <div class="send" @click="send()">发送至邮箱</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "",
  data() {
    return {
      fileInfo: {},
      fileName: "",
      fileSize: "",
      type: "",
      pdfUrl: "",
    };
  },
  methods: {
    download() {
      window.open(this.pdfUrl, "_blank");
    },
    send() {
      this.$weui.loading("邮件发送中");
      this.gcapi("sendExampleReportToCustomerByEmail", {
        fileName: this.fileName,
        type: this.type,
      }).then((res) => {
        this.$weui.loading().hide();
        console.log(">>>>>>>>>>>>>>", res);
        if (res.body.code == 0) {
          this.$weui.dialog({
            title: "发送成功",
            buttons: [
              {
                label: "我知道了",
              },
            ],
          });
        } else {
          this.$weui.dialog({
            title: "发送失败",
            buttons: [
              {
                label: "我知道了",
              },
            ],
          });
        }
      });
    },
  },
  props: {},
  components: {},
  computed: {},
  mounted() {
    console.log("comeFrom>>>>>>>>>>", this.$route.query.comeFrom);
    let comeFrom = this.$route.query.comeFrom;
    console.log("pdfName>>>>>>>>>>", this.$route.query.pdfName);
    console.log("pdfSize>>>>>>>>>>", this.$route.query.pdfSize);

    this.fileSize = this.$route.query.pdfSize;
    this.fileName = this.$route.query.pdfName;
    if (comeFrom === "order") {
      this.pdfUrl =
        "https://www.genechemat.com:8444/previewPdf/3?fileName=" +
        this.fileName;
      console.log("this.pdfUrl>>>>>>>>>>>", this.pdfUrl);
    } else if (comeFrom === "cart") {
    } else {
      this.fileInfo = JSON.parse(this.$route.params.pdfInfo);
      this.fileName = this.fileInfo.fileName;
      this.fileSize = this.fileInfo.fileSize;
      this.type = this.fileInfo.type;
      (this.pdfUrl =
        "https://www.genechemat.com:8444/previewPdf/" +
        this.type +
        "?fileName=" +
        this.fileName),
        console.log(this.pdfUrl);
    }
  },
  created() {},
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 25px;
  padding-right: 25px;
  height: 100%;
  align-items: center;
  background: #fafafa;
  img {
    margin-top: 66px;
    width: 73px;
    height: 79px;
  }
  p {
    color: #424242;
    font-size: 12px;
  }
  .down {
    color: #ffffff;
    background-color: #5878fa;
    border-radius: 44px;
    text-align: center;
    width: 100%;
    line-height: 44px;
    margin-top: 20px;
  }

  .send {
    width: 100%;
    text-align: center;
    color: #5878fa;
    border: 1px solid #5878fa;
    line-height: 44px;

    margin-top: 20px;
    background-color: #ffffff;
    border-radius: 44px;
    margin-bottom: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// PdfPage.vue?4485c3b0